const TIME_ZONE = 'Asia/Ho_Chi_Minh';

/** Chuỗi kiểu "YYYY-MM-DD HH:MM:SS" (CURRENT_TIMESTAMP của SQLite / nowIso của API). */
const SQL_TIMESTAMP = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?$/;

/**
 * Backend lưu thời điểm theo UTC nhưng KHÔNG kèm hậu tố "Z". `new Date()` sẽ
 * hiểu chuỗi dạng đó là giờ máy người dùng — hiển thị lệch 7 tiếng trên máy VN.
 * Vì vậy phải tự gắn "Z" trước khi parse.
 */
function parseUtc(value: string): Date {
  return new Date(SQL_TIMESTAMP.test(value) ? `${value.replace(' ', 'T')}Z` : value);
}

/**
 * Thứ tự phần tử do locale quyết định (vi-VN cho ra "10:00 02/10/2026"), nên
 * tự ghép từ các phần để mọi nơi hiển thị đúng "dd/MM/yyyy HH:mm".
 */
const PARTS_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  // hourCycle 'h23' thay vì hour12:false — tránh lỗi trả "24:00" lúc nửa đêm trên vài engine.
  hourCycle: 'h23',
});

function parts(date: Date): Record<string, string> {
  const result: Record<string, string> = {};
  for (const part of PARTS_FORMATTER.formatToParts(date)) {
    result[part.type] = part.value;
  }
  return result;
}

/** Định dạng thời điểm sang "dd/MM/yyyy HH:mm" theo giờ Việt Nam (UTC+7). */
export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—';
  const date = parseUtc(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const p = parts(date);
  return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}`;
}

/** Định dạng thời điểm với timezone indicator (ví dụ: "02/10/2026 10:00 UTC+7"). */
export function formatDateTimeWithTimezone(iso?: string | null): string {
  if (!iso) return '—';
  const formatted = formatDateTime(iso);
  if (formatted === '—' || formatted === iso) return formatted;
  return `${formatted} ${TIME_ZONE}`;
}

/** Định dạng thời điểm sang "dd/MM/yyyy" theo giờ Việt Nam (UTC+7), không kèm giờ. */
export function formatDate(iso?: string | null): string {
  if (!iso) return '—';
  const date = parseUtc(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const p = parts(date);
  return `${p.day}/${p.month}/${p.year}`;
}
